"use client"

// 共有 SSE hook の driver 用ラッパ（authClient を注入）。CONTENT_EVENT / 型はそのまま再エクスポート。
import { authClient } from "@/lib/auth"
import {
  useContentEvents as useContentEventsShared,
  CONTENT_EVENT,
  type ContentEventPayload,
} from "@new-cti/frontend-shared/auth/hooks"

export { CONTENT_EVENT }
export type { ContentEventPayload }

export function useContentEvents(
  eventTypes: string[],
  onEvent: (type: string, payload: ContentEventPayload | null) => void,
) {
  return useContentEventsShared(authClient, eventTypes, onEvent)
}
